//import { History } from 'history';
// import { DividendTableRowType } from '../components/home/commercial/AdditionalPurchase';
// import { DIVIDEND_MATCHED_UNMATCHED_DATA_TYPE } from '../components/home/portfolios/utils';
//import { CommercialRootPath } from './constants';

// export const maskMobileNumber = (mobileNumber: string) => {
//   if (!mobileNumber) {
//     return "";
//   }
//   return mobileNumber.replace(/\d(?=\d{4})/g, "x").replace("+", "x");
// };

// export const maskAccountNo = (accountNo: string) => {
//     if (!accountNo) return;
//     return accountNo.replace(/\d(?=\d{4})/g, 'x');
// };

export const maskEmail = (email: string) => {
  if (!email) return "";
  let parts = email.split("@");
  parts[0] = parts[0].slice(0, -4) + parts[0].slice(-4).replace(/\w/g, "x");
  return parts[0] + "@" + parts[1];
};

export const maskPan = (pan: string) => {
  if (!pan) return "";
  return pan.slice(0, -6) + "xxxxxx";
};

// export const getHoldingTypeValue = (value: string) => {
//     switch (value) {
//         case 'allHoldings':
//             return 'ALL';
//         case 'zeroHoldings':
//             return 'ZERO';
//         case 'nonZeroHoldings':
//             return 'NON-ZERO';
//         default:
//             break;
//     }
// };

const SALT = "X2lMZWFwUH";
const SALT2 = "BTVRJel9pTGVhcF";
export function EncodeBase64(value: string): string {
  const encodeValue = btoa(value);
  const encodeSubString = removeEqualOperator(encodeValue);
  const encodePassword = btoa(`${SALT}${encodeSubString}${SALT2}`);
  return encodePassword;
}

export function removeEqualOperator(value: string = "") {
  const lastTwoIndex = value.length - 2;
  let encodeString = value.slice(0, lastTwoIndex);
  const slicedStr = value.slice(lastTwoIndex, value.length);
  slicedStr.split("").forEach((char) => {
    if (char !== "=") {
      encodeString += char;
    }
  });
  return encodeString;
}

// export const getQueryParams = (search: string = ' ') => {
//     return (
//         search
//             .slice(1)
//             .split('&')
//             .map((item) => {
//                 let arr = item.split('=');
//                 return arr[1];
//             }) || []
//     );
// };

export const _debounce = (
  debounceFn: Function,
  delay: number,
  fn?: Function
) => {
  let time: any;
  return function (args: any) {
    if (!!fn && typeof fn === "function") {
      fn.call({}, args);
    }
    if (time) {
      clearTimeout(time);
    }
    time = setTimeout(() => debounceFn.call({}, args), delay);
  };
};

export const getMatchAndUnMatchedFunds = (
  filters: Function[],
  data: any[],
  addDisable?: boolean
) => {
  const { matchedData: activeRows, unMatchedData: disabledRows }: any =
    data.reduce(
      (prev: any, curr: any) => {
        const valid = filters.every((func: Function) => func.call({}, curr));
        if (valid) {
          return {
            ...prev,
            matchedData: [...prev.matchedData, curr],
          };
        }
        return {
          ...prev,
          unMatchedData: [
            ...prev.unMatchedData,
            {
              ...curr,
              ...(curr.isDisabled || addDisable ? { isDisabled: true } : {}),
            },
          ],
        };
      },
      {
        matchedData: [],
        unMatchedData: [],
      }
    );
  return [...activeRows, ...disabledRows];
};

// type mobileRedirectProps = {
//     url: string;
//     redirectionPage: string;
//     history: History
// }

// export function handleRedirectOnMobile({url,history,redirectionPage = 'kyc-status'}:mobileRedirectProps) {
//     // const onExit = () => {
//     //     history.push(`${CommercialRootPath}/${redirectionPage}/${reqId}`);
//     //  }
//     const onBeforeLoad = (params: any, callback: any) => {
//         if (params.url.includes(redirectionPage)) {
//             ref.close();
//             const _urlArgs = params.url.split('/');
//             const reqId = _urlArgs.pop();
//             if (!!reqId) {
//                 const url = `${CommercialRootPath}/${redirectionPage}/${reqId}`;
//                 history.push(url);
//                 return;
//             }
//             history.push('/');
//         } else {
//             callback(params.url);
//         }
//     };
//     const onLoadStart = (event: any) => {
//         if (event.url.includes(redirectionPage)) {
//             ref.close();
//             const _urlArgs = event.url.split('/');
//             const reqId = _urlArgs.pop();
//             if (!!reqId) {
//                 const url = `${CommercialRootPath}/${redirectionPage}/${reqId}`;
//                 history.replace(url);
//                 return;
//             }
//             history.replace('/');
//         }
//     };
//     const _window: any = window;
//     const options =
//         _window?.device?.platform === 'Android'
//             ? 'hideurlbar=yes,hidenavigationbuttons=yes,beforeload=get'
//             : 'location=no,hidenavigationbuttons=yes,beforeload=get';
//     const ref = _window.cordova.InAppBrowser.open(url, '_blank', options);
//     // ref.addEventListener('exit', onExit)
//     ref.addEventListener('beforeload', onBeforeLoad);
//     ref.addEventListener('loadstart', onLoadStart);
// }
export function isError(formikState: any, value: string) {
  return formikState.touched[value] && formikState.errors[value];
}

export function showHelperText(formikState: any, value: string) {
  return formikState.touched[value] && !!formikState.errors[value]
    ? formikState.errors[value]
    : "";
}
export const maskMobileNumber = (mobileNumber: string) => {
  if (!mobileNumber) {
    return "";
  }
  return mobileNumber.replace(/\d(?=\d{4})/g, "x").replace("+", "x");
};
export const formatDate = (dateString: string): string => {
  const [day, month, year] = dateString.split("/");

  const date = new Date(Number(year), Number(month) - 1, Number(day));

  return date.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};
